import { useEffect } from 'react';
import { BootResponse } from '../constants/apiResponses.types';
import useApi from './useApi';
import {
  ICON_FONT_STYLESHEET_HREFS,
  SHARED_UI_HARDCODED_FONT_FAMILIES,
  resolveThemeFontHrefs,
} from '../utils/googleFonts';

export default function useThemeFont() {
  const API = useApi({});
  const publisherMetaData = API.getPublisherMeta.data as BootResponse;

  const storeTheme = publisherMetaData?.storeTheme;
  const fontHrefs = resolveThemeFontHrefs([
    storeTheme?.general?.font,
    storeTheme?.login?.font,
    storeTheme?.login?.logoutScreen?.font,
    ...SHARED_UI_HARDCODED_FONT_FAMILIES,
  ]);
  const stylesheetHrefs = [...fontHrefs, ...ICON_FONT_STYLESHEET_HREFS];
  const stylesheetHrefsKey = stylesheetHrefs.join('|');

  useEffect(() => {
    stylesheetHrefs.forEach((href) => {
      if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    });
  }, [stylesheetHrefsKey]);
}
